import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import SupplyPage from '@/pages/supply/page';
import DemandPage from '@/pages/demand/page';
import SupplyDetailPage from '@/pages/supply-detail/page';
import DemandDetailPage from '@/pages/demand-detail/page';
import SupplyPublishPage from '@/pages/supply-publish/page';
import DemandPublishPage from '@/pages/demand-publish/page';
import DetailPage from '@/pages/detail/page';
import EnergySystemPage from '@/pages/energy-system/page';
import NewsPage from '@/pages/news/page';
import NewsDetailPage from '@/pages/news-detail/page';
import ProfilePage from '@/pages/profile/page';
import MySupplyPage from '@/pages/my-supply/page';
import MyDemandPage from '@/pages/my-demand/page';
import MyFavoritesPage from '@/pages/my-favorites/page';
import AboutPage from '@/pages/about/page';
import MessagesPage from '@/pages/messages/page';
import LoginPage from '@/pages/login/page';
import RegisterPage from '@/pages/register/page';
import ForgotPasswordPage from '@/pages/forgot-password/page';
import ResetPasswordPage from '@/pages/reset-password/page';
import AuthGuard from '@/components/feature/AuthGuard';
import AdminLoginPage from '@/pages/admin-login/page';
import AdminDashboardPage from '@/pages/admin/page';
import AdminUsersPage from '@/pages/admin-users/page';
import AdminSupplyReviewPage from '@/pages/admin-supply/page';
import AdminDemandReviewPage from '@/pages/admin-demand/page';
import AdminReportsPage from '@/pages/admin-reports/page';
import AdminAnalyticsPage from '@/pages/admin-analytics/page';
import AdminNewsManagePage from '@/pages/admin-news/page';
import AdminSettingsPage from '@/pages/admin-settings/page';
import AdminAuthGuard from '@/components/feature/AdminAuthGuard';
import AgreementPage from '@/pages/agreement/page';
import UserProfilePage from '@/pages/user-profile/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/supply',
    element: <SupplyPage />,
  },
  {
    path: '/u/:id',
    element: <UserProfilePage />,
  },
  {
    path: '/supply/:id',
    element: <AuthGuard><SupplyDetailPage /></AuthGuard>,
  },
  {
    path: '/demand',
    element: <DemandPage />,
  },
  {
    path: '/demand/:id',
    element: <AuthGuard><DemandDetailPage /></AuthGuard>,
  },
  {
    path: '/supply-publish',
    element: <AuthGuard><SupplyPublishPage /></AuthGuard>,
  },
  {
    path: '/demand-publish',
    element: <AuthGuard><DemandPublishPage /></AuthGuard>,
  },
  {
    path: '/detail/:type/:id',
    element: <AuthGuard><DetailPage /></AuthGuard>,
  },
  {
    path: '/energy-system',
    element: <EnergySystemPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/profile',
    element: <AuthGuard><ProfilePage /></AuthGuard>,
  },
  {
    path: '/my-supply',
    element: <AuthGuard><MySupplyPage /></AuthGuard>,
  },
  {
    path: '/my-demand',
    element: <AuthGuard><MyDemandPage /></AuthGuard>,
  },
  {
    path: '/my-favorites',
    element: <AuthGuard><MyFavoritesPage /></AuthGuard>,
  },
  {
    path: '/messages',
    element: <AuthGuard><MessagesPage /></AuthGuard>,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/agreement/:type',
    element: <AgreementPage />,
  },
  // ─── 管理后台 ───
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminAuthGuard><AdminDashboardPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/users',
    element: <AdminAuthGuard><AdminUsersPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/supply',
    element: <AdminAuthGuard><AdminSupplyReviewPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/demand',
    element: <AdminAuthGuard><AdminDemandReviewPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/reports',
    element: <AdminAuthGuard><AdminReportsPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/analytics',
    element: <AdminAuthGuard><AdminAnalyticsPage /></AdminAuthGuard>,
  },
  {
    path: '/admin/news',
    element: <AdminAuthGuard><AdminNewsManagePage /></AdminAuthGuard>,
  },
  {
    path: '/admin/settings',
    element: <AdminAuthGuard><AdminSettingsPage /></AdminAuthGuard>,
  },
];

export default routes;